<template>
  <div
    data-qa="bonus_levels"
    class="d-flex flex-column gr-3 loyalty-bonus-levels text-center"
  >
    <div
      v-if="bonusLevels.length === 1"
      data-qa="bonus_levels_solo"
      class="d-flex align-center mx-auto"
    >
      <v-icon
        color="special"
        size="28"
      >
        ui-icon-four-pointed-star-fill
      </v-icon>
      <span class="text-stat-item text--text">
        <span data-qa="bonus_levels_item_bonus">{{ bonusLevels[0].percent_amount }}</span>%
      </span>
    </div>
    <template v-else>
      <div class="d-flex justify-center gc-1 py-2 px-4 w-100">
        <template v-for="({ percent_amount, need_spend }, index) in bonusLevels">
          <div
            v-if="index !== 0"
            :key="`${percent_amount}-${need_spend}-line`"
            class="loyalty-bonus-levels__item loyalty-bonus-levels__item--line"
          >
            <span class="text-h6">&nbsp;</span>
            <div class="loyalty-bonus-levels__line font-size-12 rounded-pill special" />
          </div>
          <div
            :key="`${percent_amount}-${need_spend}`"
            class="loyalty-bonus-levels__item loyalty-bonus-levels__item--bonus"
          >
            <span class="text-h6 text--text text-no-wrap">
              <span data-qa="bonus_levels_item_percent">{{ percent_amount }}</span>%
            </span>
            <span class="font-size-12 ui-icon-four-pointed-star-fill special--text" />
            <span
              class="text-caption-2 text-secondary--text text-no-wrap"
              data-qa="bonus_levels_item_spending_need_spend"
            >
              {{ formatPrice({ price: need_spend }) }} {{ context.currency.symbol }}
            </span>
          </div>
        </template>
      </div>
      <span
        class="text-body-2 text-secondary--text"
        :class="{ 'text-pre-line': isMobile }"
      >{{ t('Размер бонуса зависит от\nобщей суммы трат в клинике', options) }}</span>
    </template>
  </div>
</template>

<script lang="ts" setup>
import I18NextVue from 'i18next'
import formatPrice from 'src/functions/formatPrice'
import useIsMobile from 'src/composables/useIsMobile'
import useContextStore from 'src/store/useContextStore'
import type { BonusLevel, ContextStore } from 'src/components/common/LpuLoyaltyProgram/types'

const { t, language } = I18NextVue
const options = { ns: language }

defineProps<{
  bonusLevels: BonusLevel[]
}>()

const { context }: ContextStore = useContextStore()

const isMobile = useIsMobile()
</script>

<style lang="scss" scoped>
.font-size-12 {
  font-size: 12px;
}

.loyalty-bonus-levels {
  &__item {
    display: flex;
    flex-direction: column;
    align-items: center;
    row-gap: 4px;

    &--bonus {
      width: 24px;
    }

    &--line {
      flex-grow: 1;
      max-width: 80px;
      margin-right: -3px;
      margin-left: -3px;
    }
  }

  &__line {
    height: 6px;
    width: 100%;
    margin-top: calc((1em - 6px) / 2);
  }
}
</style>
